<template>
  <div class="mapdata_filter_container">
    <div class="mapdata_filters_uppercontainer">
      <div class="mapdata_filter_innercontainer">
        <div class="mapdata_filter_title">
          {{ $t('sale') }} / {{ $t('rent') }}
        </div>
        <div class="mapdata-filter-slider-container">
          <div class="container-popover-selector">
            <div class="container-checks container-checks--sale">
              <radioButton v-model="currentFilter.sale.c_tipo_contrato" input-value="Venta" :label="$t('sale')" />
            </div>

            <div v-if="currentFilter.sale.c_tipo_contrato === 'Venta'" class="container-checks container-checks--new-dev-2en-hand">
              <checkBox v-model="currentFilter.sale.c_tipo_producto" input-value="Obra nueva" :label="$t('new-dev')" />
              <checkBox v-model="currentFilter.sale.c_tipo_producto" input-value="Segunda mano" :label="$t('chartsData.2nd-hand')" />
            </div>

            <div class="container-checks">
              <radioButton v-model="currentFilter.sale.c_tipo_contrato" input-value="Alquiler" :label="$t('rent')" />
            </div>
          </div>
        </div>
        <div class="mapdata_filter_title title-margin">
          {{ $t('maps.main-typo') }}
        </div>
        <div class="mapdata-filter-slider-container">
          <div class="container-popover-selector">
            <div class="container-checks">
              <checkBox v-model="currentFilter.flat.flat_type" input-value="all" :label="$t('valuationFilters.all')" />
            </div>

            <h3 class="mt-1">{{ $t("dataSelectors.residential") }}</h3>
            <div class="container-checks container-checks--typologies">
              <checkBox v-model="currentFilter.flat.flat_type" input-value="flat" :label="$t('dataSelectors.flat')" />
              <checkBox v-model="currentFilter.flat.flat_type" input-value="house" :label="$t('dataSelectors.house')" />
              <checkBox v-model="currentFilter.flat.flat_type" class="label-strong" input-value="industrial" :label="$t('dataSelectors.industrial')" />
              <checkBox v-model="currentFilter.flat.flat_type" class="label-strong" input-value="office" :label="$t('dataSelectors.office')" />
              <checkBox v-model="currentFilter.flat.flat_type" class="label-strong" input-value="landplot" :label="$t('dataSelectors.land-plot')" />
              <checkBox v-model="currentFilter.flat.flat_type" class="label-strong" input-value="retail" :label="$t('dataSelectors.retail')" />
              <checkBox v-model="currentFilter.flat.flat_type" class="label-strong" input-value="hospitality" :label="$t('dataSelectors.hospitality')" />
            </div>

            <h3 class="mt-2">{{ $t("dataSelectors.other") }}</h3>
            <div class="container-checks container-checks--typologies">
              <checkBox v-model="currentFilter.flat.flat_type" input-value="parking" :label="$t('valuationFilters.parking')" />
              <checkBox v-model="currentFilter.flat.flat_type" input-value="storage" :label="$t('valuationFilters.storage')" />
              <checkBox v-model="currentFilter.flat.flat_type" input-value="other" :label="$t('dataSelectors.other')" />
            </div>
          </div>
        </div>
      </div>

      <div class="mapdata_filter_innercontainer mapdata_filter_innercontainer_maring">
        <div class="mapdata_filter_title">
          {{ $t('valuationFilters.size') }}
        </div>
        <div class="mapdata-filter-slider-container">
          <div class="container-popover-selector popover-beds">
            <h3 class="fs-16">{{ $t("valuationFilters.bedrooms") }}</h3>
            <div class="container-checks-beds mt-1">
              <div class="row-check-beds">
                <label for="0" :class="{ 'is-checked-bed': currentFilter.rooms.rooms_num.includes(0) }">0</label>
                <input id="0" v-model.number="currentFilter.rooms.rooms_num" type="checkbox" value="0">
              </div>
              <div class="row-check-beds">
                <label for="beds-1" :class="{ 'is-checked-bed': currentFilter.rooms.rooms_num.includes(1) }">1</label>
                <input id="beds-1" v-model.number="currentFilter.rooms.rooms_num" type="checkbox" value="1">
              </div>
              <div class="row-check-beds">
                <label for="beds-2" :class="{ 'is-checked-bed': currentFilter.rooms.rooms_num.includes(2) }">2</label>
                <input id="beds-2" v-model.number="currentFilter.rooms.rooms_num" type="checkbox" value="2">
              </div>
              <div class="row-check-beds">
                <label for="beds-3" :class="{ 'is-checked-bed': currentFilter.rooms.rooms_num.includes(3) }">3</label>
                <input id="beds-3" v-model.number="currentFilter.rooms.rooms_num" type="checkbox" value="3">
              </div>
              <div class="row-check-beds">
                <label for="beds-4" :class="{ 'is-checked-bed': currentFilter.rooms.rooms_num.includes(4) }">4</label>
                <input id="beds-4" v-model.number="currentFilter.rooms.rooms_num" type="checkbox" value="4">
              </div>
              <div class="row-check-beds">
                <label for="beds-5" :class="{ 'is-checked-bed': currentFilter.rooms.rooms_num.includes(5) }">4+</label>
                <input id="beds-5" v-model.number="currentFilter.rooms.rooms_num" type="checkbox" value="5">
              </div>
            </div>

            <br>
            <div class="container-input">
              <h3 class="fs-16">{{ $t("valuationFilters.sqm") }}</h3>
              <div class="row-label-input">
                <div class="row-input">
                  <input id="sqm_min" v-model="currentFilter.sqm_filter.sqm.min" type="number" name="sqm_min" placeholder="Min" min="0" @blur="addSqmFilterMin">
                  <input id="sqm_max" v-model="currentFilter.sqm_filter.sqm.max" type="number" name="sqm_max" placeholder="Max" min="0" @blur="addSqmFilterMax">
                </div>
              </div>
            </div>
            <div class="container-checks mt-1">
              <checkBox v-model="currentFilter.sqm_filter.all_sqm" width="no-full-width" :input-value="true" :label="$t('valuationFilters.all')" />
            </div>
          </div>
        </div>

        <div class="mapdata_filter_title title-margin">
          {{ $t('valuationFilters.features') }}
        </div>
        <div class="mapdata-filter-slider-container">
          <div class="container-checks container-checks--size mt-1">
            <checkBox v-model="currentFilter.other_features.c_elevator" :input-value="true" :label="$t('valuationFilters.elevator')" />
            <checkBox v-model="currentFilter.other_features.c_parking" :input-value="true" :label="$t('valuationFilters.parking')" />
            <checkBox v-model="currentFilter.other_features.c_storage" :input-value="true" :label="$t('valuationFilters.storage')" />
          </div>
        </div>

        <div class="mapdata_filter_title title-margin">
          {{ $t('price') }}
        </div>
        <div class="mapdata-filter-slider-container">
          <div class="container-popover-selector">
            <div class="container-input">
              <div class="row-label-input">
                <label for="price_min">{{ $t("valuationFilters.price-eur") }}</label>
                <div class="row-input">
                  <input id="price_min" v-model="currentFilter.prices.price.min" type="number" name="price_min" placeholder="Min" min="0" @blur="addPriceMin">
                  <input id="price_max" v-model="currentFilter.prices.price.max" type="number" name="price_max" placeholder="Max" min="0" @blur="addPriceMax">
                </div>
              </div>
              <lineSeparator :space-between="1" />
              <div class="row-label-input">
                <label for="price_min_sqm">{{ $t("valuationFilters.price-eur-sqm") }}</label>
                <div class="row-input">
                  <input id="price_min_sqm" v-model="currentFilter.prices.price_sqm.min" type="number" name="price_min_sqm" placeholder="Min" min="0" @blur="addPriceSqmMin">
                  <input id="price_max_sqm" v-model="currentFilter.prices.price_sqm.max" type="number" name="price_max_sqm" placeholder="Max" min="0" @blur="addPriceSqmMax">
                </div>
              </div>
              <lineSeparator :space-between="1" />
              <div class="row-label-input">
                <label for="price_min_rent">{{ $t("valuationFilters.rent-eur-mo") }}</label>
                <div class="row-input">
                  <input id="price_min_rent" v-model="currentFilter.prices.rent_mo.min" type="number" name="price_min_rent" placeholder="Min" min="0" @blur="addPriceRentMin">
                  <input id="price_max_rent" v-model="currentFilter.prices.rent_mo.max" type="number" name="price_max_rent" placeholder="Max" min="0" @blur="addPriceRentMax">
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="mapdata_filter_innercontainer">
        <div class="mapdata_filter_title">
          {{ $t('more') }}
        </div>
        <div class="mapdata-filter-slider-container">
          <div class="container-popover-selector">
            <div class="container-input">
              <div class="row-label-input-slide">
                <label for="search_radius">{{ $t("valuationFilters.search-radius") }}</label>
                <input
                  id="search_radius"
                  v-model.number="currentFilter.more_filters.search_radius"
                  type="number"
                  name="search_radius"
                  :placeholder="$t('valuationFilters.search-radius')"
                  min="150"
                  @change="searchRadiusDefault"
                >
              </div>
            </div>
            <lineSeparator :space-between="1" />
            <div class="container-checks">
              <checkBox v-model="currentFilter.more_filters.published" class="label-strong row-check" :input-value="true" :label="$t('valuationFilters.published')" />
              <checkBox v-model="currentFilter.more_filters.unpublished" class="label-strong row-check" :input-value="true" :label="$t('valuationFilters.unpublished')" />
              <checkBox v-model="currentFilter.more_filters.rec_unpublished" class="label-strong row-check" :input-value="true" :label="$t('valuationFilters.recently-unpublished')" />
            </div>
            <lineSeparator :space-between="1" />
            <div class="container-input">
              <div class="row-label-input">
                <label for="construct_year_min">{{ $t("valuationFilters.construction-year") }}</label>
                <div class="row-input">
                  <input
                    id="construct_year_min"
                    v-model="currentFilter.more_filters.construct_year.min"
                    type="number"
                    name="construct_year_min"
                    placeholder="Min"
                    min="0"
                    @blur="addConstructYearMin"
                  >
                  <input
                    id="construct_year_max"
                    v-model="currentFilter.more_filters.construct_year.max"
                    type="number"
                    name="construct_year_max"
                    placeholder="Max"
                    min="0"
                    @blur="addConstructYearMax"
                  >
                </div>
              </div>
            </div>
            <lineSeparator :space-between="1" />
            <div class="container-checks">
              <checkBox v-model="currentFilter.more_filters.exact_location" class="label-strong row-check" :input-value="true" :label="$t('valuationFilters.exact-location')" />
            </div>
            <lineSeparator :space-between="1" />
            <div class="">
              <div class="">
                <label for="in_date_min">{{ $t("valuationFilters.in-date") }}</label>
                <div class="row-input-date">
                  <div class="row-input-cross">
                    <input id="in_date_min" v-model="currentFilter.more_filters.in_date.min" type="date" name="in_date_min" placeholder="Min">
                    <span v-if="currentFilter.more_filters.in_date.min !== ''" @click="clearActualDate('inDateMin')"><font-awesome-icon icon="times" /> </span>
                  </div>
                  <!-- <input id="in_date_min" v-model="currentFilter.more_filters.in_date.min" type="date" name="in_date_min" placeholder="Min"> -->
                  <!-- <input id="in_date_max" v-model="currentFilter.more_filters.in_date.max" type="date" name="in_date_max" placeholder="Max"> -->
                  <div class="row-input-cross">
                    <input id="in_date_max" v-model="currentFilter.more_filters.in_date.max" type="date" name="in_date_max" placeholder="Max">
                    <span v-if="currentFilter.more_filters.in_date.max !== ''" @click="clearActualDate('inDateMax')"><font-awesome-icon icon="times" /> </span>
                  </div>
                </div>
              </div>
            </div>
            <lineSeparator :space-between="1" />
            <div class="">
              <div class="">
                <label for="exit_date_min">{{ $t("valuationFilters.exit-date") }}</label>
                <div class="row-input-date">
                  <div class="row-input-cross">
                    <input id="exit_date_min" v-model="currentFilter.more_filters.exit_date.min" type="date" name="exit_date_min" placeholder="Min" class="mt-1">
                    <span v-if="currentFilter.more_filters.exit_date.min !== ''" @click="clearActualDate('exitDateMin')"><font-awesome-icon icon="times" /> </span>
                  </div>
                  <!-- <input id="exit_date_min" v-model="currentFilter.more_filters.exit_date.min" type="date" name="exit_date_min" placeholder="Min" class="mt-1"> -->
                  <!-- <input id="exit_date_max" v-model="currentFilter.more_filters.exit_date.max" type="date" name="exit_date_max" placeholder="Max"> -->
                  <div class="row-input-cross">
                    <input id="exit_date_max" v-model="currentFilter.more_filters.exit_date.max" type="date" name="exit_date_max" placeholder="Max">
                    <span v-if="currentFilter.more_filters.exit_date.max !== ''" @click="clearActualDate('exitDateMax')"><font-awesome-icon icon="times" /> </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mapdata_filters_footer">
      <div class="mapdata_filters_footer_right">
        <button class="brains-type3-btn mr-1" @click="clearValuationFilters()"><font-awesome-icon icon="trash" /></button>
        <button class="brains-type1-btn" @click="applyValuationFilters(false)">Apply Filters</button>
      </div>
    </div>
  </div>
</template>
<script>
import radioButton from '@/components/designComponents/radioButton'
import checkBox from '@/components/designComponents/checkBox'
import lineSeparator from '@/components/designComponents/line-separator'
import { mapState } from 'vuex'
export default {
  name: 'ValuationFilter',
  components: { radioButton, checkBox, lineSeparator },
  data() {
    return {
      loading: false,
      currentFilter: {
        c_pais: 'IT',
        c_longitud: null,
        c_latitud: null,
        c_categorias: [],
        c_polygon: [],
        sale: {
          c_tipo_contrato: 'Venta',
          c_tipo_producto: ['Obra nueva', 'Segunda mano']
        },
        flat: {
          flat_type: ['flat']
        },
        rooms: {
          rooms_num: []
        },
        other_features: {
          c_elevator: false,
          c_parking: false,
          c_storage: false
        },
        sqm_filter: {
          sqm: {
            min: '',
            max: ''
          },
          all_sqm: false
        },
        prices: {
          price: {
            min: '',
            max: ''
          },
          price_sqm: {
            min: '',
            max: ''
          },
          rent_mo: {
            min: '',
            max: ''
          }
        },
        more_filters: {
          search_radius: 300,
          published: true,
          unpublished: false,
          rec_unpublished: true,
          construct_year: {
            min: '',
            max: ''
          },
          exact_location: false,
          re_websites: '',
          in_date: {
            min: '',
            max: ''
          },
          exit_date: {
            min: '',
            max: ''
          }
        }
      }
    }
  },
  computed: {
    ...mapState('location', {
      position: (state) => state.position
    }),
    ...mapState('valuations', {
      fromsearch: (state) => state.fromsearch
    })
  },
  watch: {
    position: function() {
      this.applyValuationFilters(true)
    }
  },
  created() {
    this.applyValuationFilters(true)
  },
  methods: {
    clearActualDate(date) {
      switch (date) {
        case 'inDateMin':
          this.currentFilter.more_filters.in_date.min = ''
          break
        case 'inDateMax':
          this.currentFilter.more_filters.in_date.max = ''
          break
        case 'exitDateMin':
          this.currentFilter.more_filters.exit_date.min = ''
          break
        case 'exitDateMax': {
          this.currentFilter.more_filters.exit_date.max = ''
          break
        }
        default:
          break
      }
    },
    /**
     * Función para establecer la fecha minima de publicacion de 1 año
     */
    initDateValues() {
      const date = new Date()

      const day = date.getDate()
      const month = date.getMonth() + 1
      const year = date.getFullYear() - 2

      if (month < 10) {
        this.currentFilter.more_filters.in_date.min = `${year}-0${month}-${day}`
      } else {
        this.currentFilter.more_filters.in_date.min = `${year}-${month}-${day}`
      }
    },
    searchRadiusDefault() {
      if (this.currentFilter.more_filters.search_radius === '' || this.currentFilter.more_filters.search_radius < 150) {
        this.currentFilter.more_filters.search_radius = 150
      }
      if (this.currentFilter.more_filters.search_radius > 10000) {
        this.currentFilter.more_filters.search_radius = 10000
      }
    },
    clearValuationFilters() {
      this.currentFilter = {
        c_pais: 'IT',
        c_longitud: null,
        c_latitud: null,
        c_categorias: [],
        c_polygon: [],
        sale: {
          c_tipo_contrato: 'Venta',
          c_tipo_producto: ['Obra nueva', 'Segunda mano']
        },
        flat: {
          flat_type: ['flat']
        },
        rooms: {
          rooms_num: []
        },
        other_features: {
          c_elevator: false,
          c_parking: false,
          c_storage: false
        },
        sqm_filter: {
          sqm: {
            min: '',
            max: ''
          },
          all_sqm: false
        },
        prices: {
          price: {
            min: '',
            max: ''
          },
          price_sqm: {
            min: '',
            max: ''
          },
          rent_mo: {
            min: '',
            max: ''
          }
        },
        more_filters: {
          search_radius: 300,
          published: true,
          unpublished: false,
          rec_unpublished: true,
          construct_year: {
            min: '',
            max: ''
          },
          exact_location: false,
          re_websites: '',
          in_date: {
            min: '',
            max: ''
          },
          exit_date: {
            min: '',
            max: ''
          }
        }
      }
      // this.applyValuationFilters()
    },
    applyValuationFilters(fromgeo) {
      const vm = this
      if (!vm.position.longitude) {
        vm.$message({
          message: vm.$t('position-not-selected'),
          type: 'error'
        })
        return
      }
      // debugger
      if (vm.fromsearch) { return true }
      vm.$store.dispatch('valuations/setfilteringByGeolevel', fromgeo)
      vm.currentFilter.c_longitud = vm.position.longitude
      vm.currentFilter.c_latitud = vm.position.latitude
      vm.loading = true
      vm.$store.dispatch('valuations/getcomparables', vm.currentFilter).then(() => {
        vm.loading = false
      }).catch(() => {
        vm.loading = false
        vm.$message({
          message: vm.$t('valuations.errorcomparbles'),
          type: 'error'
        })
      })
    },
    addPriceMin() {
      return 0
    },
    addPriceMax() {
      return 0
    },
    addPriceSqmMin() {
      return 0
    },
    addPriceSqmMax() {
      return 0
    },
    addPriceRentMin() {
      return 0
    },
    addPriceRentMax() {
      return 0
    },
    addSqmFilterMin() {
      return 0
    },
    addSqmFilterMax() {
      return 0
    },
    addConstructYearMin() {
      return 0
    },
    addConstructYearMax() {
      return 0
    }
  }
}
</script>

<style lang="scss" scoped>
.mapdata_filter_innercontainer_maring {
  margin-left: 30px;
  margin-right: 30px;
}
.mapdata_filter_container {
  display: flex;
  flex-direction: column;
  width: 50vw;
  height: 82vh;
  font-family: "Montserrat-Regular",sans-serif;
  background-color: white;
  border: 1px solid rgb(221, 221, 221);
  box-sizing: border-box;

  .mapdata_filters_uppercontainer {
    height: calc(100% - 40px);
    padding: 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    overflow: scroll;
  }

  .mapdata_filters_footer {
    height: 40px;
    width: 100%;
    border-top: 1px solid lightgrey;
    display: flex;
    padding: 4px;

    .mapdata_filters_footer_right {
      margin-left: auto;
      margin-right: 15px;
    }
  }

  .disabled-slider {
    pointer-events: none;
    opacity: 0.4;
  }

  .mapdata_filter_innercontainer {
    width: 45%;
    height: 100%;
  }
  .mapdata_filter_title {
    font-size: 16px;
    font-family: "Montserrat-SemiBold",sans-serif;
    border-bottom: 2px solid #1e3cff;
  }
  .title-margin {
    margin-top: 25px;
  }

  .mapdata-filter-slider-container {
    margin-top: 20px;
    width: 100%;

    .mapdata-filter-slider-subtitle {
      color: grey;
      font-size: 12px;
      margin-bottom: 4px;
    }
  }

  .container-popover-selector {
    margin-top: -10px;
    /* background-color: lightgrey; */
    padding: 3px;
    max-height: unset;
  }

.label-strong {
  font-weight: 600;
}

.el-checkbox__label,
.el-radio__label {
  padding-left: 0;
}

.el-checkbox__inner {
  width: 12px;
  height: 12px;

  &::after {
    left: 3px;
    top: 0;
  }
}

.el-slider__button {
  border-radius: 0;
  width: 10px;
  height: 20px;
  background-color: #1e3cff;
}

.el-slider__bar {
  background-color: initial;
}

.popover-more-filters .brains-popover-container {
  margin-top: 8px !important;
  border-radius: 4px !important;

  .container-popover-selector {
    width: 300px;
  }
}

.popover-sale-filters .brains-popover-container {
  margin-top: 8px !important;
  border-radius: 4px !important;

  .container-popover-selector {
    width: 180px;
    padding-bottom: 5px;
  }
}

.popover-typologies-filters .brains-popover-container {
  margin-top: 8px !important;
  border-radius: 4px !important;

  .container-popover-selector {
    width: 180px;
    padding-bottom: 5px;
    padding-top: 5px;
  }
}

.popover-size-filters .brains-popover-container {
  margin-top: 8px !important;
  border-radius: 4px !important;

  .container-popover-selector {
    width: 270px;
    padding-bottom: 5px;
    padding-top: 5px;
  }
}

.popover-price-filters .brains-popover-container {
  margin-top: 8px !important;
  border-radius: 4px !important;

  .container-popover-selector {
    width: 250px;
    padding-bottom: 5px;
    padding-top: 5px;
  }
}

.container-checks {
  &--sale {
    margin-bottom: 5px;
  }
  &--new-dev-2en-hand div {
    margin-bottom: 5px;
  }
  &--typologies div {
    margin-bottom: 5px;
  }
  &--size div {
    margin-bottom: 5px;
  }
}

.row-input-cross {
  display: grid;
  grid-template-columns: 87% 13%;
  text-align: center;
  align-items: center;

  span {
    font-size: 20px;
    color: #1e3cff;
    cursor: pointer;
  }
}
.el-select-dropdown__item {
  border-top: 1px solid lightgray;
}

.el-select-dropdown__item {
  border-top: 1px solid lightgray;
  height: 38px !important;
}

.icon-refresh-container {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  margin-left: 5px;

  span {
    font-weight: 600;
    margin-left: 8px;
  }

  svg {
    cursor: pointer;
  }
}

.row-valuation-filters {
  margin-left: -5px;
  margin-right: -5px;
  display: flex;
  justify-content: flex-start;
  gap: 10px;
}

.container-checks {
  .row-check {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2px;

    .no-strong {
      font-weight: 400;
    }
  }
  .checkbox-reverse {
    flex-direction: row-reverse;
  }

  .checkbox-allsqm {
    justify-content: flex-end;
    gap: 10px;
    font-weight: 600;
  }
}

.popover-beds {
  padding-right: 10px;
}

.container-checks-beds {
  display: flex;
  flex-wrap: wrap;

  .row-check-beds {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 32px;
    height: 32px;
    background-color: white;
    border-radius: 50px;
    margin-right: 4px;
    border: 1px solid #1e3cff;
    cursor: pointer;

    label {
      font-size: 16px;
      cursor: pointer;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50px;
    }

    input {
      display: none;
    }

    .is-checked-bed {
      background-color: #1e3cff;
    }
  }
}

.container-popover-selector {
  .container-input {
    .row-label-input {
      .row-input {
        display: flex;
        justify-content: space-between;
        gap: 20px;
        flex-wrap: wrap;
        height: 40px;

        input {
          width: 40%;
          padding-left: 10px;
        }

        ::placeholder {
          color: rgba(0, 0, 0, 0.295);
        }
      }
    }

    .row-label-input-slide {
      display: flex;
      gap: 10px;
      justify-content: flex-start;
      align-items: center;

      label {
        font-size: 18px;
      }

      input {
        height: 40px;
        padding-left: 10px;
        width: 100px;
      }
    }
  }
}

.search-radius-m {
  font-size: 16px;
  padding: 5px 0 5px 5px;
  font-weight: 800;
}

.row-input-date {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 10px;

  input {
    height: 40px;
    padding-left: 10px;
    color: rgba(0, 0, 0, 0.295);
  }
}

.icon-refresh-container {
  color: #1e3cff;
}
}
</style>
